import React from 'react';

export const StickyUpgradeCTA: React.FC = () => {
  const userId = (() => {
    try {
      const v = localStorage.getItem('sleepcalc_user_id');
      return v || 'guest';
    } catch {
      return 'guest';
    }
  })();

  const buildUrl = (prodId: string) =>
    `https://www.creem.io/payment/${prodId}?customer_id=${encodeURIComponent(
      userId
    )}&success_url=${encodeURIComponent('https://sleepcalc-pro.pages.dev/?payment=success')}&cancel_url=${encodeURIComponent(
      'https://sleepcalc-pro.pages.dev/?payment=cancel'
    )}`;

  return (
    <div
      className="fixed right-4 bottom-20 flex flex-col gap-2 z-[3000]"
      style={{ pointerEvents: 'auto' }}
    >
      <a
        href={buildUrl('prod_10w6tRy1qlvUVAkyiDgX7E')}
        target="_blank"
        rel="noreferrer noopener"
        className="px-4 py-2 rounded-lg text-white bg-gradient-to-r from-blue-600 to-cyan-600 shadow-lg hover:shadow-xl font-semibold"
        data-role="upgrade-cta"
      >
        Upgrade to Pro ($4.99/mo)
      </a>
      <a
        href={buildUrl('prod_2mKSW1peZ6P7A1MpZNlcdc')}
        target="_blank"
        rel="noreferrer noopener"
        className="px-4 py-2 rounded-lg text-white bg-gradient-to-r from-purple-600 to-indigo-600 shadow-lg hover:shadow-xl font-semibold"
        data-role="upgrade-cta"
      >
        Upgrade to Premium ($39/yr)
      </a>
    </div>
  );
};

